import _ from 'lodash';

import {
  Stack,
  Typography
} from '@mui/material';
import {
  GlAccountTypeName,
  StandardGlAccountsTableQuery,
  useStandardGlAccountsTableQuery
} from 'generated/graphql';
import { SimpleDataTable } from 'modules/components/layer22';
import { useMemo } from 'react';



export type StandardGlAccountsTableProps = {
  listedCompanyId: string;
  accountTypes: GlAccountTypeName[];
};

export const FC = ({
  listedCompanyId, accountTypes
}: StandardGlAccountsTableProps) => {
  const {
    data,
    loading
  } = useStandardGlAccountsTableQuery({
    skip: !listedCompanyId || _.isEmpty(accountTypes),
    variables: {
      listedCompanyId,
      accountTypes
    }
  });

  return (
    <Stack gap={4}>
      {data?.standardGlAccounts.map((account) => (
        <GlAccountTable
          key={account.id}
          account={account}
        />
      ))}

    </Stack>
  );
};



function GlAccountTable({
  account
}: {
  account: StandardGlAccountsTableQuery['standardGlAccounts'][number];
}) {
  const values = useMemo(
    () => account.values.filter((v) => v.period !== 'fy'),
    [account]
  );

  const years = useMemo(
    () => _.takeRight(_.sortBy(_.uniq(values.map((v) => v.year.toString()))), 5),
    [values]
  );

  const periods = useMemo(
    () => _.sortBy(_.uniq(values.map((v) => v.period.toUpperCase()))),
    [values]
  );

  return (
    <Stack gap={1}>
      <Typography>
        {account.displayName}
      </Typography>

      <SimpleDataTable.FC
        emptyCasePlaceholder='-'
        domain={years}
        range={periods}
        data={values.map((v) => ({
          x: v.year.toString(),
          y: v.period.toUpperCase(),
          value: v.formattedValue
        }))}
      />
    </Stack>
  );
}
